module.exports = __webpack_public_path__ + "img/provisaologo.469faafb.png";